import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(
    localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("authtoken") ||
      ""
  );
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!(
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("authtoken")
    )
  );

  useEffect(() => {
    const fetchJourneyStep = async () => {
      const storedToken =
        localStorage.getItem("token") ||
        localStorage.getItem("authToken") ||
        localStorage.getItem("authtoken");
      if (storedToken) {
        setToken(storedToken);
        setIsAuthenticated(true);
      }
    };

    fetchJourneyStep();
  }, []);

  const login = (newToken) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("authToken", newToken);
    localStorage.setItem("authtoken", newToken);
    setToken(newToken);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("authtoken");
    localStorage.removeItem("profile_id");
    localStorage.removeItem("phone_number");
    setToken("");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

